<template>
	<div class="list-item">
		<div class="customerName">
			<span v-if="dataItem.customerOrderFollowUpH24No == 1" style="color: red;">{{ dataItem.customerName }}</span>
			<span v-else-if="dataItem.customerOrderFollowUpColorValue == 1"
				style="color: green;">{{ dataItem.customerName }}</span>
			<span v-else>{{ dataItem.customerName }}</span>
			<van-tag :color="dataItem.noFollowUpRemindCssValue">{{ dataItem.noFollowUpRemind || '--' }}</van-tag>
		</div>
		<div>
			<template v-if="Array.isArray(dataItem.customerOrg) && dataItem.customerOrg.length">
				<p v-for="org in dataItem.customerOrg" :key="org.id">{{ org.orgName }}</p>
			</template>
			<span v-else>--</span>
		</div>
		<div>
			<span>跟进时间</span>
			<span>{{ dataItem.followUpTime | dateFormat }}</span>
		</div>
		<div>
			<span>跟进人</span>
			<span>{{ dataItem.followUpPersonName || '--' }}</span>
		</div>
		<div>
			<span>流量归属人</span>
			<span>{{ dataItem.flowPartnerName || '--' }}</span>
		</div>
		<div>
			<span>客户意向</span>
			<span>{{ dataItem.customerIntention || '--' }}</span>
		</div>
		<div>
			<span>已购标签(产品)</span>
			<p>
				<span v-for="(item,index) in dataItem.projectLable" :key="index" style="margin-left: 10px;">
					<span
						:style="item.writeOffStatus === 0 ? 'color:#FF9900;' : (item.writeOffStatus === 1 ? 'color:green;' : 'color:red;')">
						{{ item.name }}
					</span>
				</span>
			</p>
			<!-- <span style="flex: 1; padding-left: 20px;">{{ dataItem.lableName }}</span> -->

		</div>
		<div>
			<span>已购标签(课程)</span>
			<p>
				<span v-for="(item,index) in dataItem.courseLable" :key="index" style="margin-left: 10px;">
					<span
						:style="item.writeOffStatus === 0 ? 'color:#FF9900;' : (item.writeOffStatus === 1 ? 'color:green;' : 'color:red;')">
						{{ item.name }}
					</span>
				</span>
			</p>
			<!-- <span style="flex: 1; padding-left: 20px;">{{ dataItem.lableName }}</span> -->
			
		</div>
		<div>
			<span>跟进状态</span>
			<span style="flex: 1; padding-left: 20px;" v-if="dataItem.customerOrderFollowUpNeedTotal > 0">
				<span
					:style="dataItem.customerOrderFollowUpNeedTotal > 0 ? (dataItem.customerOrderFollowUpColorValue == 1 ? 'color:green;' : 'color:red;') : 'color:black;'">
					{{ dataItem.customerOrderFollowUpNeedTotal > 0 ? (dataItem.customerOrderFollowUpColorValue == 1 ? '跟进已全部完成' : '跟进未完成') : '' }}
				</span>
			</span>
		</div>
		<div class="footer border-top">
			<slot name="footer" :item="dataItem" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CustomerItem',
		props: {
			dataItem: {
				type: Object,
				require: true
			}
		},
		created() {}
	};
</script>

<style lang="less" scoped>
	.list-item {
		margin-bottom: 10px;
		background-color: #fff;
		padding-top: 10px;

		.customerName {
			font-size: 14px;
			color: #333;
		}

		.tags {
			justify-content: start;

			.van-tag {
				padding-left: 0;
				padding-right: 10px;
				line-height: 24px;

				&::before {
					display: none;
				}
			}
		}

		.footer {
			padding: 0;
			margin-top: 5px;

			.van-button {
				width: 100%;
				text-align: center;
				border: none;
				height: 40px;

				&__content {
					justify-content: center;
					color: #169bd5;
				}
			}
		}

		div {
			display: flex;
			justify-content: space-between;
			font-size: 12px;
			color: #969799;
			padding: 0 16px;
			line-height: 24px;

			span {
				max-width: calc(~'100vw - 20px');
				overflow: hidden;
				word-wrap: break-word;

				&:last-child {
					text-align: right;
				}
			}
		}
	}
</style>
